module.exports = __webpack_public_path__ + "img/mission.e2bf9a19.jpg";